import type { Note } from '@eigtech/notes-types'
import { isNil } from 'lodash-es'
import { formatBreakingSpaces } from './formatMessage'

export function getMessageData(note: Note) {
  if (!isNil(note.text)) {
    // formatting persists across platforms by using
    // a line break.  These need to be converted to newlines to display
    // properly in the text area
    return formatBreakingSpaces(note.text)
  }
  return '(Information Unavailable)'
}
